import React, { useEffect, useState } from "react";
import { Loader2, MessageSquare, Flag, TrendingUp, UserCog, ToggleLeft, LifeBuoy, Hand } from "lucide-react";
import { api } from "@/lib/api";
import { PREDICTION_LABELS as PL, VOTE_2022_LABELS as VL } from "@/lib/constants";

const TL_META = {
  baseline: { icon: Flag, color: "#475569", label: (e) => `2022 Seçim Sonucu: ${VL[e.detail] || e.detail || "-"}` },
  prediction: { icon: TrendingUp, color: "#0EA5E9", label: (e) => `2026 tahmin: ${PL[e.old] || e.old || "?"} → ${PL[e.detail] || e.detail}` },
  caller: { icon: UserCog, color: "#0F2C59", label: (e) => `Sorumlu: ${e.old || "?"} → ${e.detail}` },
  status: { icon: ToggleLeft, color: "#F59E0B", label: (e) => `Durum: ${e.old || "?"} → ${e.detail}` },
  note: { icon: MessageSquare, color: "#10B981", label: (e) => `Not: "${e.detail}"` },
  pool: { icon: LifeBuoy, color: "#06B6D4", label: (e) => `${e.title}${e.detail ? `: "${e.detail}"` : ""}` },
  pool_claim: { icon: Hand, color: "#059669", label: (e) => `Havuzdan devraldı${e.detail ? ` → ${e.detail}` : ""}` },
};

function tlDate(iso) {
  try { return new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
}

export default function TimelineView({ voterId, showIntro = true }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    if (voterId) api.get(`/voters/${voterId}/timeline`).then(({ data }) => setData(data));
  }, [voterId]);
  if (!voterId) return null;
  if (!data) return <div className="py-10 grid place-items-center"><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>;
  return (
    <div className="py-2" data-testid="timeline-view">
      {showIntro && (
        <p className="text-sm text-muted-foreground mb-4">
          Bu firmanın 2022 sonucundan bugüne kadar tahmin, sorumlu ve durum değişimleri:
        </p>
      )}
      <div className="relative pl-6">
        <div className="absolute left-[9px] top-1 bottom-1 w-px bg-border" />
        <div className="space-y-5">
          {data.events.map((e, i) => {
            const meta = TL_META[e.type] || TL_META.note;
            const Icon = meta.icon;
            return (
              <div key={i} className="relative" data-testid="timeline-event">
                <div className="absolute -left-6 top-0 h-[19px] w-[19px] rounded-full grid place-items-center ring-4 ring-background" style={{ background: meta.color }}>
                  <Icon className="h-3 w-3 text-white" />
                </div>
                <div className="flex items-start justify-between gap-2">
                  <p className="text-sm text-foreground leading-snug">{meta.label(e)}</p>
                  <span className="text-[11px] text-muted-foreground whitespace-nowrap shrink-0">{tlDate(e.date)}</span>
                </div>
                {e.actor && <p className="text-[11px] text-muted-foreground mt-0.5">{e.actor}</p>}
              </div>
            );
          })}
          {data.events.length === 0 && <p className="text-sm text-muted-foreground">Kayıt yok.</p>}
        </div>
      </div>
    </div>
  );
}
